const getters = {
  getPartners: state => state.partners,
  getAllPartners: state => state.allPartners
}

const actions = {
  setPartners ({ commit }, data) {
    commit('setPartners', data)
  },
  setAllPartners ({ commit }, data) {
    commit('setAllPartners', data)
  }
}

const mutations = {
  setPartners (state, data) {
    state.partners = data
  },
  setAllPartners (state, data) {
    state.allPartners = data.map(item => {
      return {
        ...item,
        full_name: `${item.first_name ?? ''} ${item.last_name ?? ''}`
      }
    })
  }
}

const state = {
  partners: {},
  allPartners: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
